import styled from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import Button from '../../../components/Button';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
`;

const KYCRejection = ({ onClose, onContinue, title, text }) => {
  return (
    <StyledModal
      onClose={() => {
        onClose();
      }}
    >
      <ContentContainer>
        <ParagraphLargeText>KYC Verification Rejected</ParagraphLargeText>
        <BodyLarge>
          Unfortunately, we couldn't verify your identity with the information
          provided. If you believe this is a mistake, contact our support team
          for assistance.
        </BodyLarge>
        <ButtonContainer>
          <Button
            onClick={async () => {
              onClose();
            }}
          >
            Continue
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </StyledModal>
  );
};

export default KYCRejection;
